$(function() {
  fade('.toggleWrap');

  // Add smooth scroll and prevent URL hash update
  $('.toggleWrap a').on('click', function(event) {
    var target = $(this).attr('href');
    if (target.startsWith('#')) {
      event.preventDefault(); // Prevent default anchor click behavior
      var targetElement = $(target);
      if (targetElement.length) {
        $('html, body').animate({
          scrollTop: targetElement.offset().top
        }, 600); // Adjust scroll speed as needed
      }
      $('#toggle').click(); // Close the menu after clicking
    }
  });

  // Handle external links separately
  $('.toggleWrap a[target="_blank"]').on('click', function() {
    $('#toggle').click(); // Close the menu after clicking
  });
});

function fade(elm) {
  var $fade = $(elm),
      $body = $('body');
  $fade.addClass('hide');

  $('#toggle').on('click', function() {
    $fade.toggleClass('hide').addClass('animation');
    $('.trigger').toggleClass('active');
    if ($fade.hasClass('hide')) {
      $body.removeClass('no-scroll').off('.noScroll');
    } else {
      $body.addClass('no-scroll').on('touchmove.noScroll', function(e) {
        e.preventDefault();
      });
    }
  });
}